// Request object for login/token acquisition
export const loginRequest = {
    scopes: ["openid", "profile", process.env.VUE_APP_API_SCOPE || ""]
};
